import script from "./VerifyAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./VerifyAccount.vue?vue&type=script&setup=true&lang=ts"

import "./VerifyAccount.vue?vue&type=style&index=0&id=022e65c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-022e65c6"]])

export default __exports__